<template>
  <a-modal
    title="查看退款"
    :maskClosable="false"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleCancel"
    @cancel="handleCancel"
  >
    <div class="inner">
      <!-- 退款详情 -->
      <refund-info :refundDetail="refundDetail"></refund-info>

      <!-- 退款单变更记录 -->
      <refund-record-list
        v-if="refundDetail.operationProcessList && refundDetail.operationProcessList.length > 0"
        :dataList="refundDetail.operationProcessList"
      ></refund-record-list>
    </div>
  </a-modal>
</template>

<script>
import refund from '../../../api/refund'

import RefundRecordList from './RefundRecordList'

import RefundInfo from './RefundInfo'

export default {
  name: 'refundFormModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      refundDetail: {}, //展示退款详情的容器
      tabIndex: '0', //审核操作选择按钮
      textbookPrice: null, //教材费价格
      coursePrice: null, //课时费价格
      remark: '', //退款备注
      id: '',
    }
  },
  components: {
    RefundRecordList,
    RefundInfo,
  },
  methods: {
    //初始化，显示
    init(params) {
      this.visible = true
      //初始化form表单数据
      if (params) {
        this.id = params.id
        this.getRefundDetail()
      }
    },

    //获取退款详情
    getRefundDetail() {
      refund.get(this.id).then(res => {
        console.log('退款详情：', res.data)
        this.refundDetail = res.data
        this.textbookPrice = res.data.applyRefundTextbookFee
          ? res.data.applyRefundTextbookFee / 100
          : null
        this.coursePrice = res.data.applyRefundCourseFee
          ? res.data.applyRefundCourseFee / 100
          : null
      })
    },

    //隐藏
    handleCancel() {
      this.visible = false
      this.$emit('closeForm')
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.inner {
  padding: 0px 30px;
  max-height: calc(100vh - 300px);
  overflow: auto;
}

.tab-oper {
  text-align: center;
  margin-top: 20px;
  > button {
    margin-right: 10px;
  }
}
.tab-content {
  margin-top: 20px;
  > .item {
    line-height: 30px;
    padding: 10px 0px;
    > .key {
      display: inline-block;
      width: 120px;
      text-align: right;
      vertical-align: top;
      > .must {
        color: red;
      }
    }
    > .value {
      display: inline-block;
      width: calc(100% - 120px);
      > .desc {
        display: inline-block;
        color: $normal-color-dark;
        margin-left: 6px;
      }
      > .textarea {
        height: 100px;
      }
    }
  }
}
</style>
